import { useEffect, useState } from 'react'

import css from './sass/itembid.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import { calculateMaxPurchaseAmount } from './utils'

export default function FixedItemAmountSelector({ item, amount, setAmount}) {

  const [maxAllowed, setMaxAllowed] = useState()

  useEffect(() => {
    const newMax = calculateMaxPurchaseAmount(item)
    setMaxAllowed(newMax)
  }, [amount, item])

  const subtractAmount = () => {
    if (amount > 1) setAmount(amount - 1)
  }

  const addAmount = () => {
    //if amount is not a number, reset to 1
    if (!(typeof amount === 'number')) {
      setAmount(1)
      return
    }

    //allow add if is less than max allowed
    if (amount < maxAllowed) setAmount(amount + 1)
  }

  const disabledAddButton = () => {
    if (!(typeof amount === 'number')) return true
    if (amount >= maxAllowed) return true
    return false
  }

  if (!item) return <></>

  return (
    <div className={css['fixed-amount-container']}>
      <p className={css['fixed-amount-text']}>
        Quantity?
      </p>
        
      <div className={css['fixed-amount-inputs']}>
        
        <button disabled={amount <= 1} className={`${css['fixed-amount-button']} ${themeCss['shadowed']}`} 
          onClick={() => subtractAmount()}> - </button>

        <input type='number' value={amount} onChange={(e) => setAmount(parseInt(e.target.value))} />

        <button 
        disabled={disabledAddButton()} 
        className={`${css['fixed-amount-button']} ${themeCss['shadowed']}`} 
          onClick={() => addAmount()}> + </button>
        
      </div>
    </div>
  )
}